/**
 * SGKC027A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ApprvAuthorityInfoDto {

    /**
     * 単価権限管理ID
     */
    tankaauthorityManagementid?: string;
    /**
     * 単価権限管理名称
     */
    tankaauthorityManagementname?: string;
    /**
     * 表示順
     */
    hyojiTurn?: string;
}

